export default "__VITE_ASSET__99f32481__"